import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Switch from "react-switch";
import Select from "react-select";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { FoodContext } from "../../../../../contexts/Food";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const CommentAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  //getting context values here
  let { 
    loading, 
    setLoading,
    commentTypeForSearch, 
    setPaginatedCommentType,
    foodGroupForSearchForPOS,
    foodForPOS,
  } = useContext(FoodContext);
  const { branchForSearch } = useContext(RestaurantContext);

  const toastObj = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  //item state
  const [newComment, setNewComment] = useState({
    name: "",
    short_code:"",
    comment_type:"",
    branch: "",
    food: "",
    food_group: "",
    comment_type: "",
    status: 1,
  });

  //useEffect == componentDidMount()
  useEffect(() => {
    if(!commentTypeForSearch){
      setPaginatedCommentType(1)
    }
  }, []);

  useEffect(()=>{
    if (id && commentTypeForSearch) {
      setTimeout(() => {
        getSpecificItem();
      }, 0);
    }
  },[commentTypeForSearch])

  const getSpecificItem = async () => {
    setLoading(true);
    if (id) {
      const url =
        BASE_URL + "/settings/comments/" + id;
      try {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if (res.data) {
          // console.log("check type data==>",res.data);
          const item = res.data;
          const comment = commentTypeForSearch && commentTypeForSearch.find((item) => item.name === res.data.comment_type);
          setNewComment({
            ...newComment,
            name: item.comment,
            short_code: item.short_code,
            comment_type: comment,
            food_group: item.food_group,
            food: item.food_item,
            branch: item.branch,
            status: item.status
          })
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(`${_t(t("Please try again."))}`, toastObj);
      }
    }
  };

  const handleSetChange = (e) =>{
    setNewComment({
      ...newComment,
      [e.target.name] : e.target.value
    })
  }

  const handleSetSelect = (key, value)=>{
    setNewComment({
      ...newComment,
      [key] : value,
    })
  }

  const handleStatus = ()=>{
    setNewComment({
      ...newComment,
      status : newComment.status === 1 ? 0 : 1,
    })
  }

  //post req of food item add
  const commentItemAxios = async () => {
    setLoading(true);
    const endpoint = id ? `/settings/comments/${id}` : "/settings/comments";
    const url = BASE_URL + endpoint;
    let formData = {
      comment: newComment.name,
      short_code: newComment.short_code,
      comment_type: newComment.comment_type?.name ?? "",
      food_group_id: newComment.food_group?.id ?? "",
      food_id: newComment.food?.id ?? "",
      branch_id: newComment.branch?.id ?? "",
      status: newComment.status,
    };
    try {
      const method= id ? "put" : "post";
      const res = await axios[method](url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res){
        toast.success(`${_t(t("Data has been added"))}`, toastObj);
        setLoading(false);
        history.push("/dashboard/manage/food/comment");
      }
    } catch (error) {
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, toastObj);
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (newComment.name && newComment.comment_type) {
      commentItemAxios();
    } else {
      toast.error(`${_t(t("Please Select All Fields"))}`, toastObj);
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t(id ? "Edit Comment" : "Add Comment"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading} />
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {id
                                  ? _t(t("Edit Comment"))
                                  : _t(t("Add Comment"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <form
                        className="row card p-2 mx-3 mb-5 table-text"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                      >
                        <div className="col-12">
                          <div className="row">
                            <div className="form-group col-4 mt-2">
                              <div className="mb-2 ">
                                <label
                                  htmlFor="name"
                                  className="control-label"
                                >
                                  {_t(t("Name"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="name"
                                  name="name"
                                  placeholder="e.g. testing"
                                  value={newComment.name || ""}
                                  required
                                  onChange={handleSetChange}
                                />
                              </div>
                            </div>

                            <div className="form-group col-4 mt-2">
                              <div className="mb-2 ">
                                <label
                                  htmlFor="short_code"
                                  className="control-label"
                                >
                                  {_t(t("Short Name"))}
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="short_code"
                                  name="short_code"
                                  placeholder="e.g. test"
                                  value={newComment.short_code || ""}
                                  onChange={handleSetChange}
                                />
                              </div>
                            </div>

                            <div className="form-group mt-2 col-4">
                              <label htmlFor="status" className="form-label mb-2">
                                {_t(t("Branch"))}{" "}
                              </label>
                              <Select
                                options={branchForSearch ?? []}
                                getOptionLabel={(a) => a.name}
                                getOptionValue={(a) => a.id}
                                value={newComment.branch}
                                onChange={(branch) => handleSetSelect("branch", branch)}
                                classNamePrefix="Menu"
                                isClearable
                                className="table-text"
                                maxMenuHeight="200px"
                                placeholder="Select Branch"
                                styles={customStyle}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group mt-2 col-4">
                              <label htmlFor="status" className="form-label mb-2">
                                {_t(t("Food Group"))}{" "}
                              </label>
                              <Select
                                options={foodGroupForSearchForPOS ?? []}
                                getOptionLabel={(a) => a.name}
                                getOptionValue={(a) => a.id}
                                value={newComment.food_group}
                                onChange={(grp) => handleSetSelect("food_group", grp)}
                                classNamePrefix="Menu"
                                isClearable
                                className="table-text"
                                maxMenuHeight="200px"
                                placeholder="Select Food group"
                                styles={customStyle}
                              />
                            </div>
                            <div className="form-group mt-2 col-4">
                              <label htmlFor="status" className="form-label mb-2">
                                {_t(t("Food Item"))}{" "}
                              </label>
                              <Select
                                options={foodForPOS ?? []}
                                getOptionLabel={(a) => a.name}
                                getOptionValue={(a) => a.id}
                                value={newComment.food}
                                onChange={(food) => handleSetSelect("food", food)}
                                isClearable
                                classNamePrefix="Menu"
                                className="table-text"
                                maxMenuHeight="200px"
                                placeholder="Select food item"
                                styles={customStyle}
                              />
                            </div>
                            <div className="form-group mt-2 col-4">
                              <label htmlFor="status" className="form-label mb-2">
                                {_t(t("Comment Type"))}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={commentTypeForSearch ?? []}
                                getOptionLabel={(a) => a.name}
                                getOptionValue={(a) => a.id}
                                value={newComment.comment_type}
                                onChange={(comment) => handleSetSelect("comment_type", comment)}
                                classNamePrefix="Menu"
                                className="table-text"
                                maxMenuHeight="200px"
                                placeholder="Select comment type"
                                styles={customStyle}
                              />
                            </div>

                            <div className="form-group mt-3 col-4">
                              <label htmlFor="status" className="form-label mb-2">
                              {_t(t("Status"))}{" "}
                              </label>
                              <div className="">
                                <Switch
                                  onChange={handleStatus}
                                  checked={newComment.status === 1}
                                  className="react-switch"
                                  name="status"
                                  height={20}
                                  width={42}
                                  offColor="#ee5253"                        
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group mt-4 pb-2">
                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push("/dashboard/manage/food/comment")
                                  }
                                >
                                  <i className="fa fa-arrow-left" aria-hidden="true"></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i>{" "}
                                  {_t(t("Save"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default CommentAction;
